export const COLOR_MAGENTA = 1; // rood
export const COLOR_YELLOW = 2;
export const COLOR_CYAAN = 3; // blue
export const COLOR_TURQUOISE = 4; // darker blue
export const COLOR_PURPLE = 5; // purple
export const COLOR_GREEN = 6; // green
